






import Vue from 'vue';

export default Vue.extend({
  name: 'new-circle-component'
});
